import axios from "../../axiosClient";

export const getMotionHeatmapData = async (
  blockCode: any,
  chartType: any,
  location: any,
  signal: any
) => {
  const res = await axios.get(
    `/slpapp/Dashboard/getMotionHeatMapDataByBlockCode/`,
    { params: { blockCode, chartType, location }, signal }
  );

  return res?.data?.data;
};

export const getMotionHeatMapDataByBlockCodeWithLevelLocation = async (
  blockCode: any,
  chartType: any,
  location: any,
  locationtype: any,
  signal: any
) => {
  const res = await axios.get(
    `/slpapp/Dashboard/GetMotionHeatMapDataByBlockCodeWithLevelLocation/`,
    {
      params: {
        blockCode,
        chartType,
        location,
        locationtype,
      },
      signal,
      paramsSerializer: {
        encode: (param: string) => encodeURIComponent(param),
      },
    }
  );

  return res?.data?.data;
};
